import React from "react";
import styles from './feedbackMobile.module.css';
import { Plus, Star } from "react-feather";
import { Link } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";
import dayjs from "dayjs";

const Initials = ({ fullName }) => {
  const parts = fullName.trim().split(" ");
  if (parts.length >= 2) {
    return (
      parts[0].charAt(0).toUpperCase() +
      parts[parts.length - 1].charAt(0).toUpperCase()
    );
  }
  return parts[0].substring(0, 2).toUpperCase();
}

const FeedbackMobile = ({ isPanelOpen, onToggle, feedbacks }) => {
  const [feedbackList, setFeedbackList] = useState([]);

  useEffect(() => {
    if (feedbacks) {
      setFeedbackList(feedbacks);
    }
  }, [feedbacks]);

  return (
    <>
      <div className={`${styles.AccordionList}`}>
        <div className={`${styles.AccordionListHead} ${isPanelOpen ? styles.Open : ""}`} onClick={() => onToggle("six")}>
          <p className={`${styles.Title}`}>Feedback</p>
          <img src="/static/img/downTriangle.svg" />
        </div>
        <div className={`${styles.AccordionListBody} ${isPanelOpen ? styles.Open : ""}`}>
          <div className={`${styles.TabBodySec}`}>
            {feedbackList?.map(item => {
              return <div className={`${styles.WorkOrderCard}`}>
                <div className={`${styles.CardAvatar}`}>
                  <p><Initials fullName={item?.tenant_name} /></p>
                </div>
                <div className={`${styles.CardDetails}`}>
                  <p className={`${styles.Title}`}>{item.tenant_name}</p>
                  <p className={`${styles.SubTitle}`}>Tenant, Apt - {item.tenant_apt}</p>
                  <p className={`${styles.SubTitle}`}>{dayjs(item?.created_at).fromNow()}</p>
                  <div className={`${styles.RateStarDiv}`}>
                    <Link className={(item.rating >= 1) ? `${styles.StarNote} ${styles.StarNoteActive}` : `${styles.StarNote}`}><Star /></Link>
                    <Link className={(item.rating >= 2) ? `${styles.StarNote} ${styles.StarNoteActive}` : `${styles.StarNote}`}><Star /></Link>
                    <Link className={(item.rating >= 3) ? `${styles.StarNote} ${styles.StarNoteActive}` : `${styles.StarNote}`}><Star /></Link>
                    <Link className={(item.rating >= 4) ? `${styles.StarNote} ${styles.StarNoteActive}` : `${styles.StarNote}`}><Star /></Link>
                    <Link className={(item.rating === 5) ? `${styles.StarNote} ${styles.StarNoteActive}` : `${styles.StarNote}`}><Star /></Link>
                  </div>
                  <p className={`${styles.Description}`}>{item.description}</p>
                </div>
              </div>
            })}

            {feedbackList.length === 0 && <div className={`${styles.NoDataMainWithBU}`}>
              <div>
                <div className={`${styles.NoDataIMGWithBU}`}><img src="/static/img/no-feedback.png" alt="" /></div>
                <p className={`${styles.NoDataTextWithBU}`}>Feedback List is Empty</p>
                <p className={`${styles.NoDataTextSubWithBU}`}>No feedback has been submitted yet.</p>
                {/* <button className={`${styles.AddLeaseBUWithBU}`}><Plus /> Add New</button> */}
              </div>
            </div>}

          </div>
        </div>
      </div>
    </>
  )
}

export default FeedbackMobile;
